import { render, staticRenderFns } from "./FantasyDates.vue?vue&type=template&id=97ff02f6&scoped=true&"
import script from "./FantasyDates.vue?vue&type=script&lang=js&"
export * from "./FantasyDates.vue?vue&type=script&lang=js&"
import style0 from "./FantasyDates.vue?vue&type=style&index=0&id=97ff02f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ff02f6",
  null
  
)

export default component.exports